import React from 'react'

// Utils
import useUserProfile from 'modules/user/useUserProfile'
import { useIsNodeContentTruncated } from '@sketch/utils'

// Components
import { Breakpoint, Truncate } from '@sketch/components'
import { badgeForMemberRole, isInvitationRequested } from '../utils'
import {
  isMemberCurrentUser,
  getNameOrEmailFromMembership,
} from 'modules/shares/utils'

// Styles
import {
  TooltipWithTruncatedContent,
  Subtitle,
  StyledTruncate,
} from './BaseRow.styles'

// Types
import type { BaseInfoProps } from '../types'

export const BaseInfo = ({
  identifier,
  title,
  subtitle,
  role,
  inviteStatus,
}: BaseInfoProps) => {
  const [
    isSubtitleTruncated,
    subtitleRef,
  ] = useIsNodeContentTruncated<HTMLDivElement>()
  const [
    isTitleTruncated,
    titleRef,
  ] = useIsNodeContentTruncated<HTMLDivElement>()
  const { data: userData } = useUserProfile(true)

  const isSameUser = isMemberCurrentUser(userData?.me.identifier, identifier)

  const content = getNameOrEmailFromMembership(isSameUser, title, subtitle)
  const differentTitleAndSubtitle = content !== subtitle

  const invitationRequested = inviteStatus
    ? isInvitationRequested(inviteStatus)
    : undefined

  return (
    <Truncate>
      <TooltipWithTruncatedContent
        placement="top"
        spacing="10px"
        content={title}
        disabled={!isTitleTruncated}
      >
        <StyledTruncate
          ref={titleRef}
          invitationRequested={invitationRequested}
        >
          {content}
        </StyledTruncate>
        <Breakpoint on="xs">
          {badgeForMemberRole({
            role,
            inviteStatus,
          })}
        </Breakpoint>
      </TooltipWithTruncatedContent>
      {subtitle && differentTitleAndSubtitle ? (
        <TooltipWithTruncatedContent
          placement="top"
          spacing="10px"
          content={subtitle}
          disabled={!isSubtitleTruncated}
        >
          <Subtitle ref={subtitleRef}>{subtitle}</Subtitle>
        </TooltipWithTruncatedContent>
      ) : null}
    </Truncate>
  )
}
